@reference "@glow/tailwind-config/reference.css";

.li {
  @apply list-none;
  @apply cursor-pointer;
  @apply whitespace-nowrap;
  @apply mx-2;
}
